import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro"; // <-- import styles to be used
//form page
const ListBuild = (props) => {
  const {
    back,
    next,
    elements,
    buildN,
    buildM,
    buildAT,
    buildA,
  } = props;  

console.log(elements)
//cancel
  function handleBack(event) {
    event.preventDefault();
    back();
  }

  function handleNext(event) {
    event.preventDefault();
    next();
  }

  function nutritonBuild(event) {
    event.preventDefault();
    const miscE = document.getElementById('miscId')
    const nutritionE = document.getElementById('nutritionId')
    const allE = document.getElementById('allId')
    const athleticsE = document.getElementById('athleticsId')
    nutritionE.className = 'btn btn-warning'
    miscE.className = 'btn btn-outline-warning'
    athleticsE.className = 'btn btn-outline-warning'
    allE.className = 'btn btn-outline-warning'
    buildN();
  }

  function allBuild(event) {
    event.preventDefault();
    const miscE = document.getElementById('miscId')
    const nutritionE = document.getElementById('nutritionId')
    const allE = document.getElementById('allId')
    const athleticsE = document.getElementById('athleticsId')
    allE.className = 'btn btn-warning'
    miscE.className = 'btn btn-outline-warning'
    athleticsE.className = 'btn btn-outline-warning'
    nutritionE.className = 'btn btn-outline-warning'
    buildA();
  }
  function athleticBuild(event) {
    event.preventDefault();
    const miscE = document.getElementById('miscId')
    const nutritionE = document.getElementById('nutritionId')
    const allE = document.getElementById('allId')
    const athleticsE = document.getElementById('athleticsId')
    athleticsE.className = 'btn btn-warning'
    miscE.className = 'btn btn-outline-warning'
    allE.className = 'btn btn-outline-warning'
    nutritionE.className = 'btn btn-outline-warning'
    buildAT();
  }
  function miscBuild(event) {
   const miscE = document.getElementById('miscId')
   const nutritionE = document.getElementById('nutritionId')
   const allE = document.getElementById('allId')
   const athleticsE = document.getElementById('athleticsId')
   miscE.className = 'btn btn-warning'
   allE.className = 'btn btn-outline-warning'
   athleticsE.className = 'btn btn-outline-warning'
   nutritionE.className = 'btn btn-outline-warning'
    event.preventDefault();
    buildM();
  }




  //the div and form of buttons
  return (
    <div>
      <div>
      <h1
              className="text-warning justify-content-center"
              style={{ fontSize: "50px",position:'relative',top:'0em', fontFamily: '"Play", sans-serif', }}
            >
              Marketplace
            </h1>
      <ul className="nav justify-content-center" >
            <li id='allId' className="btn btn-warning" onClick={allBuild} style={{margin: '1em'}} >
                All Items
            </li>
            <li id='nutritionId'className="btn btn-outline-warning" onClick={nutritonBuild} style={{margin: '1em'}}>
                Nutrition
            </li>
            <li id='athleticsId' className="btn btn-outline-warning" onClick={athleticBuild} style={{margin: '1em'}}>
               Athletics
            </li>
            <li id="miscId" className="btn btn-outline-warning" onClick={miscBuild} style={{margin: '1em'}}>
                Misc
            </li>
          </ul>

        {elements()}

        <div className="pad-bottom">
          <button className="back btn rounded-pill text-warning" style={styles.back} onClick={handleBack}>
            <FontAwesomeIcon
                  className="text-warning"
                  icon={solid("arrow-right-from-bracket")}
                  style={{transform: 'rotate(180deg)', fontSize: 35, marginLeft: '50%'}}
                /></button>
          <button className="next btn rounded-pill text-warning" style={styles.next} onClick={handleNext}>            
          <FontAwesomeIcon
                  className="text-warning"
                  icon={solid("people-group")}
                  style={{ fontSize: 35, marginRight: '50%'}}
                /></button>
        </div>
      </div>
    </div>
  );
}

//styles
const styles = {


}

export default ListBuild